import React, {useState, useEffect} from 'react';
import { semantic } from '@lexody/design-tokens'

export default function HardDeleteRequests(props) {
  const [deleteRequests, setDeleteRequests] = useState(props.hardEraseRequests)

  // useEffect(() => {
  //   setDeleteRequests(props.hardEraseRequests)
  // }, [])

  useEffect(() => {
    setDeleteRequests(props.hardEraseRequests)
  }, [props.hardEraseRequests])

  function restoreUser(id) {
    //delete from database
    $.ajax({
      url: `../admin_restore_full_delete`,
      dataType: 'JSON',
      type: 'POST',
      data: {
        id: id
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: () => {
        //remove from view
        let newDeleteRequests = deleteRequests.filter((x) => {
          if(x.id != id) {
            return x
          }
        })
        setDeleteRequests(newDeleteRequests)
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });

  }

  function fullDeleteUser(id) {
    $.ajax({
      url: `../admin_start_full_delete_user`,
      dataType: 'JSON',
      type: 'POST',
      data: {
        id: id
      },
      header: {
        'Content-Type': 'application/json'
      },
      success: () => {
        //remove from view
        let newDeleteRequests = deleteRequests.filter((x) => {
          if(x.id != id) {
            return x
          }
        })
        setDeleteRequests(newDeleteRequests)
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  function renderDeleteRequests() {
    if(deleteRequests.length === 0) {
      return (
        <tr style={{marginTop: 10}}>
          <td style={{textAlign: 'center'}} colSpan={4}> <p>All caught up!</p> </td>
        </tr>
      )
    }

    return deleteRequests.map((request, i) => {
      return(
        <tr key={request.id} style={{marginTop: 10}}>
          <td style={{verticalAlign: 'middle'}}><img src={request.user.avatar_url} className="user_image" style={{height: 25, width: 25, borderRadius: '100%'}}/></td>
          <td style={{verticalAlign: 'middle'}}><p>{request.user.preferred_name}</p></td>
          <td style={{verticalAlign: 'middle'}}><p>{request.user.email}</p></td>
          <td style={{verticalAlign: 'middle'}}>
            <button className="blue_btn_outline" onClick={() => restoreUser(request.id)}>restore</button>
          </td>
          <td style={{verticalAlign: 'middle', textAlign: 'end'}}>
            <button className="red_btn_outline" onClick={() => fullDeleteUser(request.id)}>delete</button>
          </td>
        </tr>
      )
    })
  }

  return(
    <div className="admin_section_outline">
      <table className="admin_table">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th colSpan={2} style={{borderRadius: 10, backgroundColor: semantic.primary.surface.lighter}}><p style={{padding: 5}}>DELETE REQUESTS</p></th>
          </tr>
        </thead>
        <tbody>
        {renderDeleteRequests()}
        </tbody>
        <tfoot></tfoot>
      </table>
    </div>
  )
}
